export const config = { apiUrl: 'https://api.oxygen-dev.caple.info', appUrl: 'https://oxygen-dev.caple.info/' };
